import { Badge } from "@chakra-ui/react";

const BadgeEmailType = ({ type }) => {
    let color = "gray"
    let text = type || "ไม่ระบุ"

    switch (type) {
        case "Register":
            color = "yellow"
            text = "ลงทะเบียน"
            break;
        case "Contact":
            color = "green"
            text = "ติดต่อ"
            break;
        case "Approve":
            color = "blue"
            text = "ตรวจเอกสาร"
            break;
        case "Appointment":
            color = "orange"
            text = "แจ้งวันนัด"
            break;
        default: color = "gray"
    }

    return (
        <Badge colorScheme={color}>{text}</Badge>
    )
}

export default BadgeEmailType